
const shoppingCartHooks = ( el ) => {
  const biorexModifyShoppingCart = () => {
    const shopping_cart = [];
    const product_items = el.querySelectorAll('.js-product-quantity');
    const cart_value = el.querySelector('.js-shopping-cart-value');
    const buttons = el.querySelectorAll('.js-shopping-cart-submit');
    if (cart_value) {
      if (product_items.length) {
        for (i = 0; i < product_items.length; i++) {
          if (parseInt(product_items[i].value) > 0) {
            const product = {
              product_id: parseInt(product_items[i].getAttribute('data-id')),
              quantity: parseInt(product_items[i].value)
            }
            const seatLockId = product_items[i].getAttribute('data-seat-lock-id');
            if (seatLockId) {
              product.seat_lock_id = parseInt(seatLockId);
            }
            shopping_cart.push(product);
          }
        }
      }
      if (buttons.length) {
        for (i = 0; i < buttons.length; i++) {
          if (shopping_cart.length) {
            buttons[i].disabled = false;
          } else {
            buttons[i].disabled = true;
          }
        }
      }
      cart_value.value = JSON.stringify(shopping_cart);
    }
  };

  // Disable product quantity input
  el.querySelectorAll('.js-product-qty').forEach((elem) => {
    elem.disabled = true;
  });

  const plusInputs = el.querySelectorAll('.js-product-plus');
  const minusInputs = el.querySelectorAll('.js-product-minus');

  // Plus button
  plusInputs.forEach((elem) => {
    elem.addEventListener('click', (e) => {
      e.preventDefault();
      const input = el.querySelector(`input[data-id="${elem.getAttribute('data-field')}"]`);
      input.value = parseInt(input.value) + 1;
      biorexModifyShoppingCart();
    });
  });

  // Minus button
  minusInputs.forEach((elem) => {
    elem.addEventListener('click', (e) => {
      e.preventDefault();
      const input = el.querySelector(`input[data-id="${elem.getAttribute('data-field')}"]`);
      input.value = parseInt(input.value) - 1;
      if (input.value < 0) {
        input.value = 0;
      }
      biorexModifyShoppingCart();
    });
  });

  // Form
  var productForm = el.querySelector('.js-shopping-cart-form');
  if ( productForm ) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      // send event to be hooked on
      const event = new CustomEvent('BioRexShoppingCartSubmit', { detail: { form: this } });
      window.dispatchEvent(event);

      // temp: testing
      // return;

      biorexModifyShoppingCart();
      var cart_value = el.querySelector('.js-shopping-cart-value');
      if (cart_value) {
        var url = this.action + encodeURI('&shopping_cart=' + cart_value.value);
        window.location.href = url;
      }
    });
    var productItems = el.querySelectorAll('.js-product-quantity');
    if (productItems.length) {
      for (i = 0; i < productItems.length; i++) {
        productItems[i].addEventListener('change', function (e) {
          biorexModifyShoppingCart();
        });
      }
    }
  }
};

const maybeNavigateToWebshopTab = () => {
  // open webshop tab if user came via "login and buy" button
  if (localStorage && localStorage.getItem('biorex_view') == 'webshop') {
    var webshopTab = document.querySelector('[aria-controls="vouchers"]');
    if (webshopTab) {
      webshopTab.click();
      localStorage.removeItem('biorex_view');
    }
  }
};

/**
 * Handles modal for adding food products to an existing transaction the profile where
 * applicable (currently only cinema ID 15).
 */
const addFoodProductsModal = () => {

  const site         = document.querySelector('.js-page');
  const toggles      = document.querySelectorAll('.js-add-food-products');
  const modal        = document.querySelector('.js-add-food-products-modal');
  const modalContent = document.querySelector('.js-add-food-products-modal-content');

  // a11y dialog
  if (!modal || !modalContent || !site || !toggles) {
    return;
  }

  // setup a11y dialog
  const dialog = new A11yDialog(modal, site);

  // tasks to open visually
  const openDialog = (cinemaId, seatLockId) => {

    if (!cinemaId || !seatLockId) {
      throw new Error('Missing cinema ID or seat lock ID');
    }

    dialog.show();

    document.body.classList.add('is-active-add-food-products');

    const ajaxUrl = BioRexMain.ajaxUrl;

    // create admin-ajax POST request to br_add_food_products_callback
    const request = new XMLHttpRequest();

    // add body
    const body = new FormData();
    body.append('action', 'add_food_products');
    body.append('cinemaId', cinemaId);
    body.append('seatLockId', seatLockId);

    // send request
    request.open('POST', ajaxUrl, true);

    // send request
    request.send(body);

    // callback after request is complete
    request.onload = function() {
      if (this.status >= 200 && this.status < 400) {
        // Success!
        const response = this.response;
        modalContent.innerHTML = response;
        modalContent.classList.add('is-ready');

        const shoppingCart = modalContent.querySelector('.js-shopping');
        if (shoppingCart) {
          shoppingCartHooks(shoppingCart);
        }
      } else {
        // We reached our target server, but it returned an error
        console.error('Error: ' + this.status);
        modalContent.innerHTML = 'Virhe ladattaessa tuotteita / Error loading products';
      }
    }

  };

  dialog.on('hide', (element, event) => {
    closeDialog();
  });

  // tasks to close visually
  const closeDialog = () => {
    document.body.classList.add('is-closing-add-food-products');
    setTimeout(() => {
      document.body.classList.remove('is-active-add-food-products');
      document.body.classList.remove('is-closing-add-food-products');
      modalContent.classList.remove('is-ready');
      modalContent.innerHTML = '';
    }, 200);
  };

  for (let i = 0; i < toggles.length; i++) {
    toggles[i].addEventListener('click', (e) => {
      e.preventDefault();
      if ( document.body.classList.contains('is-active-add-food-products')) {
        dialog.hide();
      } else {
        const cinemaId = toggles[i].getAttribute('data-cinema-id');
        const seatLockId = toggles[i].getAttribute('data-seat-lock-id');
        openDialog(cinemaId, seatLockId);
      }
    });
  }

};

/**
 * Init
 */

maybeNavigateToWebshopTab();

const shoppingCart = document.querySelector('.js-shopping');
if (shoppingCart) {
  shoppingCartHooks(shoppingCart);
}

addFoodProductsModal();
